export const Mode = {
  TOP: 'top',
  BOTTOM: 'bottom',
} as const;

export type Mode = Union<typeof Mode>;
